import { t } from '../i18n/index.js';
import { ApiError, newOpId } from './api.js';
import type { OutboxEntry } from './outbox.js';
import { outbox } from './sync.js';
import { toast } from './toast.js';

/**
 * ADR 0112: Abgeleitete Arbeit (Aufgabe aus Termin, Vorgang, Thema, Notiz, Datei, Entscheidung, Ziel) entsteht nur im
 * Bereich ihres Anlasses. Fehlt dort eine Liste (`no_safe_list`), bieten wir das Anlegen an – nie still „Allgemein“.
 * `unsafe_target`: die gewählte Liste ist offener als der Anlass. Gibt `true` zurück, wenn der Fehler behandelt ist.
 */
export function safeListHandled(err: unknown, retry: () => void): boolean {
  if (!(err instanceof ApiError)) return false;
  if (err.code === 'no_safe_list') {
    toast(t('derive.noSafeList'), { kind: 'error', ms: 15000, action: { label: t('derive.createList'), run: retry } });
    return true;
  }
  if (err.code === 'unsafe_target') {
    toast(t('derive.unsafeTarget'), { kind: 'error' });
    return true;
  }
  return false;
}

/** Ausgangskorb-Eintrag erneut senden – mit neuer opId und „Liste im Bereich anlegen“ (bzw. am Folgeauftrag) */
export function resendWithSafeList(e: OutboxEntry, place: 'body' | 'followUp' = 'body') {
  const opId = newOpId();
  const body = e.body as Record<string, unknown>;
  const next = place === 'followUp' ? { ...body, opId, followUp: { ...(body.followUp as object), safeList: true } } : { ...body, opId, safeList: true };
  void outbox.enqueue({ opId, kind: e.kind, projectId: e.projectId, method: e.method, url: e.url, body: next, ...(e.overlay ? { overlay: e.overlay } : {}) }).catch(() => {});
}
